import React, { useEffect, useState, useRef } from 'react';
import Layout from '../../parts/Layout';
import { httpRequest } from '../../../services/httpService';
import helpers from '../../../services/helpers';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Loader from '../../parts/Loader';
import Dropdown from 'react-bootstrap/Dropdown'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import initTreeView from '../../../services/initTreeView';
import { TbChecklist, TbCalendar , TbEdit, TbTrash, TbFileTypePdf, TbTagStarred, TbFileInvoice  } from "react-icons/tb";
import store from '../../../services/store';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Calendar } from 'primereact/calendar';
 
export default function ContactList ({viewer = 'admin', menu = 'manage-customers', page_title = "Manage Customers"}){
    const [record_data, setRecordData] = useState([]);
    const [loading, setLoading] = useState(1);
    const [search_key, setSearchKey] = useState('');

    const [data_table, setDataTable] = useState([]);
    const [selected_items, setSelectedItems] = useState([]);
    const [selected_all, setSelectAll] = useState(false);
    const [datatable_state, setDataTableState] = useState({
        first: 0,
        rows: 10,
        page: 0,
        sortField: null,
        sortOrder: null
    });

    const [range, setRange] = useState("");
    const [soa_modal, setSOAModal] = useState(false);
    const [soa_customer_id, setSOACustomerID] = useState("");
    const calendarRef = useRef(null);

    useEffect(() => {
        initTreeView()
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows
        })
    }, []);

    useEffect(() => {
        displayDataTable(record_data)
    }, [datatable_state.sortOrder]);

    useEffect(() => {
        displayDataTable(record_data)
    }, [
        selected_items, 
        selected_all
    ]);

    useEffect(() => {
        fetchDataList({
            "page": datatable_state.page + 1,
            "per_page": datatable_state.rows,
            "search": search_key
        })
    }, [datatable_state]);

    function fetchDataList(condition = {
        "page": '',
        "search": '',
        "per_page": ''
    }){
        const page = condition.page ?? datatable_state.page
        const per_page = condition.per_page ?? datatable_state.rows
        const search = condition.search ?? search_key
        let filter = `?store_id=${helpers.getStoreID()}&paginate=1&`

        if(page){
            filter += 'page='+page+'&'
        }
        if(per_page){
            filter += 'per_page='+per_page+'&'
        }
        if(search){
            filter += 'search='+search+'&'
        }

        filter = filter.slice(0, -1)

        setLoading(1)

        const url = helpers.createUrl('V1/manage/contact/list'+filter)

        httpRequest(url, "GET", {}, true)
            .then((res) => {
                setRecordData(res)
                setLoading(0)
                displayDataTable(res)
            })
            .catch((err) => {
                //console.log(err)
                setLoading(0)

                Swal.fire({
                    title: "Error!",
                    text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }); 
    }

    function search(e){
        let { value } = e.target;
        setSearchKey(value)
        fetchDataList({
            "page": datatable_state.page + 1,
            "search": value
        })
    }

    function triggerAction(data = '', action = '', status = ''){
        let ids = [];
        if(action === 'single-delete'){
            ids.push(data.id)
        }
        else{
            ids = data.map(o => o['id']);
        }

        let title = 'Delete Contact'
        if(ids.length > 1){
            title = 'Delete Customers'
        }

        Swal.fire({
            title: title,
            text: 'This action cannot be reversed. All associated records will also be deleted. Do you want to continue?',
            showCancelButton: true,
            showConfirmButton: false,
            closeOnCancel: true,
            showDenyButton: true,
            denyButtonText: 'Yes'
        })
        .then((result) => {
            if (result.isDenied) {
                deleteItem(ids)
            }
        })
    }

    function deleteItem(id){
        const url = helpers.createUrl('V1/manage/contact/delete')
        httpRequest(url, 'POST', {
            postdata: {
                "contact_ids": id,
                "store_id": helpers.getStoreID()
            },
        }, true)
            .then((res) => {
                setLoading(0)
                fetchDataList({
                    "page": datatable_state.page + 1,
                    "per_page": datatable_state.rows,
                    "search": search_key
                })
                setSelectedItems([])

                Swal.fire({
                    title: "Success",
                    text: res.message,
                    icon: "success",
                    confirmButtonText: "OK",
                })
            })
            .catch((err) => {
                console.log(err)
                setLoading(0)
                setSelectedItems([])

                Swal.fire({
                    text: err.message,
                    //text: err.message,
                    icon: "error",
                    confirmButtonText: "OK",
                })
            }); 
    }

    function displayDataTable(data){
        setDataTable(
            <DataTable 
                className='border-top'
                dataKey={data.id}
                value={data.data} 
                // tableStyle={{ minWidth: '50rem' }}
                size="normal"
                paginator 
                rows={data.per_page} 
                rowsPerPageOptions={[5, 10, 20, 25, 50]}
                totalRecords={data.total}
                onPage={onPage}
                first={datatable_state.first}
                lazy
                currentPageReportTemplate="{first} to {last} of {totalRecords}"
                selection={selected_items} 
                onSelectionChange={onSelectItem}
                scrollHeight="500px"
                scrollable
                responsive={true}
                emptyMessage="No data to display"
            >
                <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} />
                <Column header="TYPE" body={({contact_type_id})=> helpers.filterObject(store.contact_type, contact_type_id)?.label}></Column>
                <Column field="contact_name" header="NAME" ></Column>
                <Column header="COMPANY" body={({company_name})=> company_name ? company_name : '---'}></Column>
                <Column header="EMAIL" body={({email})=> email ? email : '---'}></Column>
                <Column header="PHONE" body={({phone_no})=> phone_no ? phone_no : '---'}></Column>
                {/* <Column header="TYPE" body={({contact_type_id})=> contact_type_id == 1 ? 'Company': 'Individual'}></Column> contact_type */}
                <Column className="text-right" body={displayActionMenu}></Column> 
            </DataTable>
        )

    }

    const onPage = (e) => {
        setDataTableState(e)
        setSelectedItems([])
    };

    const onSelectItem = (e) => {
        const value = e.value;
        setSelectedItems(value);
    };

    function displayActionMenu(data){
        return (<Dropdown>
                    <Dropdown.Toggle className='btn-light border' size="sm" id={"dropdown-actions-"+data.id}>Action</Dropdown.Toggle>
                    <Dropdown.Menu align="end">
                        <Dropdown.Item key="edit" as={Link} to={`/customers/${data.id}/edit`}><TbEdit size={20} className='mr-2' />Edit</Dropdown.Item>
                        <Dropdown.Item key="service-request" as={Link} to={`/customers/${data.id}/product-units`}><TbTagStarred size={20} className='mr-2' />Products Units</Dropdown.Item>

                        <Dropdown.Item key="generate-soa" onClick={(e) => {
                            setRange("")
                            setSOACustomerID(data.id)
                            setSOAModal(true)}}
                            as={"button"}
                        ><TbFileInvoice size={20} className='mr-2' />Generate SOA</Dropdown.Item>

                        <Dropdown.Divider />
                        <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(data, 'single-delete')} 
                            as={"button"}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>)
    }

    function generateSOA(){
        if (range[0] && range[1]) {
            const url = `/service-requests/print-soa?customer_id=${soa_customer_id}&request_from=${helpers.formatDate(range[0])}&request_to=${helpers.formatDate(range[1])}`


            window.open(url, '_blank', 'noopener,noreferrer');
            setSOAModal(false)
        }
    }

    function inputDateChange(e){
        setRange(e.value);

        const [start, end] = e.value || [];
        if (start && end) {
        // Close the calendar popup
            calendarRef.current?.hide();
        }
    }

    return (
        <Layout page_title={page_title} menu={menu}>
            
            {/* <Dialog 
                header="Generate Statement of Account" 
                visible={soa_modal} 
                onHide={() => setSOAModal(false)}
                style={{ width: '30vw', overflow: 'visible' }}
                modal
            >
                <Calendar
                    value={range}
                    onChange={handleDateChange}
                    selectionMode="range"
                    readOnlyInput
                    showIcon
                    placeholder="Choose range"
                />
                <div style={{ marginTop: '1rem', textAlign: 'right' }}>
                    <Button label="Apply" className='btn btn-primary' onClick={handleApply} disabled={!range[0] || !range[1]} />
                </div>
            </Dialog> */}
            
            <Modal show={soa_modal}>
                <Modal.Header>
                    <h5>Generate Statement of Account</h5>
                    <Button variant="danger" size="sm" onClick={() => setSOAModal(false)}><i className="fas fa-times"></i></Button>
                </Modal.Header>
                <Modal.Body  style={{position: 'relative'}}>
                    <Calendar
                        ref={calendarRef}
                        value={range}
                        onChange={inputDateChange}
                        selectionMode="range"
                        readOnlyInput
                        showIcon
                        placeholder="Choose range"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={(e) => generateSOA()}>
                        Generate
                    </Button>
                    {/* <Button variant="secondary" onClick={() => setSOAModal(false)}>
                        Cancel
                    </Button> */}
                </Modal.Footer>
            </Modal>

            <div className="container-fluid" style={{position: 'relative'}}>
                    <Loader isLoading={loading}/>
                <div className="card">
                    <div className="card-header border-bottom-0">
                        <div className="row">
                            <div className="col-sm-5 col-lg-3 mb-2">
                                {/* <input type="text" className="form-control" placeholder="Search Contact" onChange={search} /> */}
                                <InputText
                                    id="search" 
                                    name="search" 
                                    value={search_key}
                                    tagClass="form-control mb-0 w-100"
                                    placeholder="Search"
                                    onChange={search}
                                    autoFocus={true}
                                    className='w-100'
                                />
                            </div>
                            <div className="col-sm-7 col-lg-9 text-right mt-2 mt-md-0">
                                <Link className='btn btn-primary float-right' to="/customers/form"><i className="fas fa-plus-circle mr-2" />New</Link>
                                
                                {selected_items.length ?
                                <Dropdown className='float-right mr-3'>
                                    <Dropdown.Toggle className='btn-light border' id={"dropdown-actions-"}>Bulk Action</Dropdown.Toggle>
                                    <Dropdown.Menu align="end">
                                        <Dropdown.Item key="delete" className='text-danger' onClick={(e) => triggerAction(selected_items)}><i className="fas fa-trash mr-2" />Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> : ''}
                            </div>
                        </div>
                    </div>
                    <div className="card-body p-0">
                        { data_table }
                    </div>
                </div>
            </div>
        </Layout>
    )
}